// import { sysGetToken, sysSetToken, sysRemoveToken } from '../../utils/sys_auth'
const operation = {
  state: {
    // 运营后台
    sysToken: '',
    sysCode: '',
    sysName: '',
    // 企业管理模块数据绑定，视图切换字段
    viewCompany: {
      status: false,
      name: '',
      id: '',
      ifinfo: true,
      server: ''
    },
    // 激活码管理模块数据绑定，视图切换字段
    viewActiveCodeModule: {
      status: false,
      ifactiveModule: true,
      name: '',
      id: '',
      notActiveNumber: 0,
      activedNumber: 0
    }
  },
  mutations: {
    // 运营后台
    SET_SYSTOKEN: (state, sysToken) => {
      state.sysToken = sysToken
    },
    SET_SYSCODE: (state, sysCode) => {
      state.sysCode = sysCode
    },
    SET_SYSNAME: (state, sysName) => {
      state.sysName = sysName
    },
    SET_VIEWCOMPANY: (state, companyInfo) => {
      state.viewCompany = companyInfo
    },
    SET_VIEWACTIVECODEMODULE: (state, activeCodeInfo) => {
      state.viewActiveCodeModule = activeCodeInfo
    }
  },
  actions: {
    sysLoginOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_SYSTOKEN', '')
        commit('SET_SYSNAME', '')
        localStorage.removeItem('operateLoginInfo')
        resolve()
      })
    },
    // 设置企业信息
    SetOperateInfo({ commit }, userInfo) {
      return new Promise(resolve => {
        commit('SET_SYSTOKEN', userInfo.token)
        commit('SET_SYSNAME', userInfo.name)
        resolve()
      })
    },
    sysSetViewCompany({ commit }, companyInfo) {
      commit('SET_VIEWCOMPANY', companyInfo)
    },
    sysSetviewActiveCodeModule({ commit }, activeCodeInfo) {
      commit('SET_VIEWACTIVECODEMODULE', activeCodeInfo)
    }
  }
}

export default operation



// WEBPACK FOOTER //
// ./src/store/modules/operation.js